module.exports = __webpack_public_path__ + "images/cartnew.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cartnew.png
// module id = espK
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15